import React from 'react';
import { RootState } from 'reducers';
import { useSelector } from 'react-redux';
import { ArrowLeft2 } from 'assets/icons';

interface Props {
	title?: string;
}

const HeaderTitle = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);

	return (
		<div className="container-header-component">
			{
				header.onBack && (
					<div className="arrow-back" onClick={ () => header.onBack() }>
						<img src={ ArrowLeft2 } />
					</div>
				)
			}
			<h2 className="header-component">
				{ props.title || header?.title }
			</h2>
		</div>
	)
}

export default HeaderTitle;